import { render, staticRenderFns } from "./CarrierFurgonetka.vue?vue&type=template&id=4106f394&scoped=true&"
import script from "./CarrierFurgonetka.vue?vue&type=script&lang=js&"
export * from "./CarrierFurgonetka.vue?vue&type=script&lang=js&"
import style0 from "./CarrierFurgonetka.vue?vue&type=style&index=0&id=4106f394&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4106f394",
  null
  
)

export default component.exports